import { render, staticRenderFns } from "./ApproveRF.vue?vue&type=template&id=64d86724"
import script from "./ApproveRF.vue?vue&type=script&lang=js"
export * from "./ApproveRF.vue?vue&type=script&lang=js"
import style0 from "./ApproveRF.vue?vue&type=style&index=0&id=64d86724&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports